export const AMAZON_INVITATION_URL = "https://sellercentral.amazon.com/account/permissions#/open-invites/delegate-invites";
export const AMAZON_URL_PROCESS_PDF = "/assets/索赔大师使用指引(对外).pdf";
